module.exports = __webpack_public_path__ + "img/danmachi5.6db3a378.jpg";